/** Codifica gmail_message_id para rutas (ids IMAP llevan ":"). */
export function encodeMessageId(gmailId) {
  return encodeURIComponent(String(gmailId ?? ""));
}

export function emailMessagePath(apiBase, gmailId, suffix) {
  const id = encodeMessageId(gmailId);
  return `${apiBase}/emails/${id}${suffix ? `/${suffix}` : ""}`;
}
